import { Button, Row } from "antd";
import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./AdnPhoneInputButton.css";

export const AdnPhoneInputButton = ({ disabled, buttonText, onClick }) => {
  const [phone, setPhone] = useState();
  return (
    <Row>
      <PhoneInput
        disabled={disabled}
        international
        defaultCountry="PT"
        placeholder="Insert phone number"
        limitMaxLength
        value={phone}
        onChange={setPhone}
      />
      <Button
        disabled={disabled}
        onClick={() => {
          if (onClick(phone)) setPhone("");
        }}
      >
        {buttonText}
      </Button>
    </Row>
  );
};
